import * as React from 'react';
import type { JsonObject } from '@/app-package';
import { ListingDoc } from '@bb/domain/dist/schemas';

import DataSetTable from './DataSetsTable';

type MoreInfoListProps = { moreInfo: JsonObject<ListingDoc>['more_info'] };

const MoreInfoList: React.FunctionComponent<MoreInfoListProps> = ({
  moreInfo,
}) => {
  const moreInfoAreaDataSets = [
    [
      {
        label: 'Total Area:',
        value:
          moreInfo.total_area.total ||
          `${moreInfo.total_area.width || ''} x ${
            moreInfo.total_area.length || ''
          }`,
      },
      {
        label: 'Office/Apt Area',
        value: moreInfo.office
          ? moreInfo.office.total ||
            `${moreInfo.office.width || ''} x ${moreInfo.office.length || ''}`
          : 'NA',
      },
      {
        label: 'Industrial Area',
        value: moreInfo.industrial
          ? moreInfo.industrial.total ||
            `${moreInfo.industrial.width || ''} x ${
              moreInfo.industrial.length || ''
            }`
          : 'NA',
      },
      {
        label: 'Retail Area',
        value: moreInfo.retail
          ? moreInfo.retail.total ||
            `${moreInfo.retail.width || ''} x ${moreInfo.retail.length || ''}`
          : 'NA',
      },
    ],
  ];

  const moreInfoMiscDataSets = [
    [
      { label: 'Zoning:', value: moreInfo.zoning },
      { label: 'Freestanding:', value: moreInfo.freestanding },
    ],
  ];

  return (
    <>
      <DataSetTable dataSets={moreInfoAreaDataSets} />
      <DataSetTable dataSets={moreInfoMiscDataSets} />
    </>
  );
};

export default MoreInfoList;
